<template>
  <div v-if="haveRangeColor && rangeColor">
    <div class="sticky-legend-compliance">
      <table class="el-table-legends table-bordered mt-4">
        <tr>
          <th
            v-for="detail in rangeColor.range_color_details"
            :style="`text-align: center; background-color: ${detail.background_color}; color: ${detail.text_color}`"
          >
            {{ detail.name }}
            <br />
            <div v-if="isPercentage">
              {{ detail.from + ' %' }} -
              {{ detail.to + ' %' }}
            </div>
            <div v-if="isMoney">
              {{ detail.from + ' $' }} -
              {{ detail.to + ' $' }}
            </div>
            <div v-if="isMoney == false && isPercentage == false">
              {{ detail.from }} -
              {{ detail.to }}
            </div>
          </th>
          <th v-if="haveNAByComplianceChart" class="na-legend">
            {{ $t('common_words.na_value') }}
          </th>
        </tr>
      </table>
    </div>
  </div>
  <div v-else>
    <div class="sticky-legend-compliance">
      <table class="el-table-legends table-bordered mt-4">
        <thead>
          <tr>
            <th class="col-2 py-1 danger-legend">
              {{ $t('common_words.bad') }}
              <br />
              &lt; 86%
            </th>
            <th class="col-2 py-1 warning-legend">
              {{ $t('common_words.regular') }}
              <br />
              86%-90%
            </th>
            <th class="col-2 py-1 success-legend">
              {{ $t('common_words.good') }}
              <br />
              91% - 94%
            </th>
            <th class="col-2 py-1 successfully-legend">
              {{ $t('common_words.very_good') }}
              <br />
              95%-100%
            </th>
            <th v-if="haveNAByComplianceChart" class="col-2 py-1 na-legend">
              {{ $t('common_words.na_value') }}
            </th>
          </tr>
        </thead>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: 'range-color-legend',
  props: {
    haveRangeColor: {
      type: Boolean,
      default: false,
    },
    rangeColor: {
      type: Object,
      default: () => {
        return null;
      },
    },
    isPercentage: {
      type: Boolean,
      default: false,
    },
    isMoney: {
      type: Boolean,
      default: false,
    },
    haveNAByComplianceChart: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style scoped>
.sticky-legend-compliance {
  position: sticky;
  top: 0;
}
.sticky-legend-compliance .el-table-legends {
  width: 100%;
  margin-bottom: 20px;
  font-size: smaller;
}

/* Colores existentes */
.danger-legend {
  background-color: #ff0000 !important;
  text-align: center;
  color: white;
}
.warning-legend {
  background-color: #ffff00 !important;
  text-align: center;
}
.success-legend {
  background-color: #008000 !important;
  text-align: center;
  color: white;
}
.successfully-legend {
  background-color: #0000ff !important;
  text-align: center;
  color: white;
}

/* Nuevo segmento NA */
.na-legend {
  background-color: #808080 !important; /* gris */
  text-align: center;
  color: white;
}
</style>
